import action from "../action";

export const GET_PARAMS = "GET_PARAMS";

let paramApiUrl = process.env.REACT_APP_PARAMETER_API;

export const getAllParams = () =>
  action({
    type: GET_PARAMS,
    payload: {
      request: {
        url: `${paramApiUrl}/common`,
        method: "GET",
      },
    },
  });

export const getGameData = (data) =>
  action({
    type: "GET_GAME_DATA",
    payload: {
      request: {
        url: `${paramApiUrl}/${data.gameName}`,
        method: "GET",
      },
    },
  });
export const getSubGameData = (data) =>
  action({
    type: "GET_SUB_GAME_DATA",
    payload: {
      request: {
        url: `${paramApiUrl}/${data.gameName}`,
        method: "GET",
      },
    },
  });

export const emptyGameData = (data) =>
  action({
    type: "EMPTY_GAME_DATA",
    data,
  });
